<script setup>
import { computed, onMounted } from 'vue';
import Auth from 'dashboard/api/auth';
import TelaDeEstado from 'dashboard/components-next/TelaDeEstado/TelaDeEstado.vue';
import {
  EMAIL_DO_SUPORTE,
  LINK_DO_SUPORTE,
} from 'dashboard/helper/suporteDoAdvup';

// O balão de suporte (quando a instalação tem um) aparece sozinho aqui: é o
// único caminho de volta de uma conta suspensa.
const temSuporte = computed(() => Boolean(window.$chatwoot));
const abrirSuporte = () => {
  window.$chatwoot?.toggleBubbleVisibility('show');
  window.$chatwoot?.toggle('open');
};

onMounted(() => {
  window.$chatwoot?.toggleBubbleVisibility('show');
});
</script>

<template>
  <TelaDeEstado
    icone="i-lucide-pause-circle"
    tom="ambar"
    :titulo="$t('APP_GLOBAL.ACCOUNT_SUSPENDED.TITLE')"
    :dica="
      $t('APP_GLOBAL.ACCOUNT_SUSPENDED.MESSAGE', { email: EMAIL_DO_SUPORTE })
    "
  >
    <button
      v-if="temSuporte"
      type="button"
      class="advup-btn-forte"
      @click="abrirSuporte"
    >
      <i class="i-lucide-message-circle" aria-hidden="true" />
      <span>{{ $t('APP_GLOBAL.ACCOUNT_SUSPENDED.FALAR') }}</span>
    </button>
    <!-- O e-mail do suporte, sempre (Fase 3A): o balão só existe quando a
         instalação tem um. -->
    <a
      :href="LINK_DO_SUPORTE"
      class="advup-btn"
      :class="temSuporte ? 'advup-btn--vazado' : 'advup-btn-forte'"
    >
      <i class="i-lucide-mail" aria-hidden="true" />
      <span>{{ $t('APP_GLOBAL.ACCOUNT_SUSPENDED.ESCREVER') }}</span>
    </a>
    <button
      type="button"
      class="advup-btn advup-btn--vazado"
      @click="Auth.logout()"
    >
      <i class="i-lucide-log-out" aria-hidden="true" />
      <span>{{ $t('APP_GLOBAL.NO_ACCOUNTS.LOGOUT') }}</span>
    </button>
  </TelaDeEstado>
</template>
